module.exports = __webpack_public_path__ + "img/expostyle_9662_tomato.a8374f50.jpg";